import React from "react";
import { Box } from "@mui/material";
import CongressionalCard, { CongressionalMember } from "./CongressionalCard";

interface CongressionalGridProps {
  members: CongressionalMember[];
  onMemberClick?: (member: CongressionalMember) => void;
}

const CongressionalGrid: React.FC<CongressionalGridProps> = ({
  members,
  onMemberClick,
}) => {
  return (
    <Box
      sx={{
        width: "100%",

        display: "grid",
        gap: 2,
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)", // 1 column on mobile
          sm: "repeat(2, minmax(0, 1fr))", // 2 columns on small tablets
          md: "repeat(2, minmax(0, 1fr))", // 2 columns on medium screens (reduced for more room)
          lg: "repeat(3, minmax(0, 1fr))", // 3 columns on large screens (reduced for more room)
          xl: "repeat(4, minmax(0, 1fr))", // 4 columns on extra large screens (reduced for more room)
        },
        // Ensure consistent card sizing
        "& > *": {
          minWidth: 0, // Prevent grid items from overflowing
        },
      }}
    >
      {members.map((member, index) => (
        <CongressionalCard
          key={`${member.name}-${index}`} // Use name + index as key since no unique ID
          member={member}
          onClick={onMemberClick}
        />
      ))}
    </Box>
  );
};

export default CongressionalGrid;
